import React from 'react';
import { Box } from '@ublend-npm/aulaui-core';
import SpaceSelectorItem from './SpaceSelectorItem';
import { Space } from './types';

type SpaceListProps = {
  spaces: Space[];
  onClick: (id: string) => void;
  onStar?: (id: string) => Promise<void>;
};

const SpaceList = ({ spaces, onClick, onStar }: SpaceListProps) => {
  return (
    <Box>
      {spaces.map(({ id, archived, name, avatar, hasActivity }) => (
        <SpaceSelectorItem
          key={id}
          spaceId={id}
          onClick={() => onClick(id)}
          onStar={onStar ? () => onStar(id) : undefined}
          archived={archived}
          avatar={avatar}
          name={name}
          hasActivity={hasActivity}
        />
      ))}
    </Box>
  );
};

export default SpaceList;
